exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".share-label{left:5px;position:relative;top:2px}.head-text{text-align:left;font-size:34px;letter-spacing:0px;opacity:1;font-weight:400;padding-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ActivityCenter/SubComponents/Note.scss
// module id = 7432
// module chunks = 101